






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SystemApi, ValueListItem } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    sys: 'systemApi'
  })
})
export default class JobTypePicker extends Vue {
  @Prop({ required: false, default: false })
  private required?: boolean;

  @Prop({ required: false, default: false })
  private hideAll?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: 'Job Type' })
  private labelOverride?: string;

  get getValue() {
    return this.value;
  }

  private sys!: SystemApi;

  jobTypes: ValueListItem[] = [];

  get jobTypesSorted() {
    if (!this.jobTypes) {
      return null;
    }
    return this.jobTypes.sort((a, b) => {
      if (a.valueListValue && b.valueListValue) {
        return a.valueListValue.localeCompare(b.valueListValue);
      }
      return 0;
    });
  }

  @Watch('propertyId', { immediate: true })
  private async loadJobTypes() {
    this.jobTypes = [];
    this.jobTypes = await this.sys.getJobTypes({
      propertyId: this.propertyId
    });
  }

  public jobTypeListContains(jobType: string) {
    let found = false;
    this.jobTypes.forEach((element) => {
      if (element.valueListValue === jobType) {
        found = true;
      }
    });
    return found;
  }
}
